<template>
    <div id="list-planCodes-component" class="w-full h-full flex flex-col">
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Plan"
            :options="planCodeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { planCodes } from "@/common/fields/platform-subscription-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "PlanCodeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        planCodeOptions() {
            return Object.entries(planCodes).map(([key, value]) => ({
                label: value,
                value: key
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
